import { ServerProduct } from '@/lib/janitsjar/Product';
import Image from 'next/image';
import { Promotion } from '@fagmobler/ui';
import ProductPrice from '@/cataloguePages/productPageWithVariants/components/ProductPrice';

type PrintModeProps = {
  product: ServerProduct;
};

export function PrintMode({ product }: PrintModeProps) {
  const firstImage = product.media?.filter((m) => m.type === 'image')?.[0];
  const tagKeys = product.tags?.map((tag) => tag.key) || [];

  if (!product) return null;

  return (
    <div className="hidden print:block py-8">
      <div className="flex justify-between mb-2">
        <Image
          src={firstImage?.url ?? '/no_image.svg'}
          alt="Product Image"
          width={400}
          height={400}
        />
        <div className="flex flex-col justify-between items-end">
          {product.price.discountPercent &&
            product.price.discountPercent > 0 && (
              <Promotion
                size="md"
                percent={product.price.discountPercent}
                innerClassName={
                  tagKeys.includes('BLACK WEEK')
                    ? 'bg-[#F4A933] text-neutral-80'
                    : ''
                }
              />
            )}
          <ProductPrice price={product.price} size="lg" />
        </div>
      </div>
      <h1 className="hd-3xl">{product.posterName}</h1>
      <span className="hd-base block mb-4">{product.posterDescription}</span>
      {!!product.texts?.shortdescription && (
        <p className="mb-5 leading-snug">{product.texts.shortdescription}</p>
      )}
      {!!product.texts?.longdescription && (
        <p className="mb-5 leading-snug">{product.texts.longdescription}</p>
      )}
      {product.properties.length > 0 && (
        <>
          <span className="border-b pb-3 my-8 hd-base block">Egneskaper</span>
          <div className="grid grid-cols-2 gap-2 items-center mb-10 md:mb-5">
            {product.properties.map((prop) => (
              <div key={prop.label} className="flex gap-2 items-center">
                <p className="hd-base font-bold">{prop.label}:</p>
                <p className="body-xs">{prop.value}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
